import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  get,
  minBy,
  noop,
  sortBy,
} from 'lodash';


import { toStartCase } from 'helpers/utils';
import {
  Badge,
  Divider,
  HighlightText,
  Toggle,
} from 'components';
import EditItemButton from 'routes/Store/components/EditItemButton';

class StoreMobileTableRow extends Component {
  static propTypes = {
    fields: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    data: PropTypes.shape({}).isRequired,
    searchText: PropTypes.string,
    isFarm: PropTypes.bool,
    isMarketPlace: PropTypes.bool,
    innerRef: PropTypes.func,
    formatMessage: PropTypes.func.isRequired,
    id: PropTypes.number,
    readOnly: PropTypes.bool,
    readOnlyForPermission: PropTypes.bool,
    updateStateData: PropTypes.func.isRequired,
    reloadStore: PropTypes.func.isRequired,
    isRetailPage: PropTypes.bool,
  };

  static defaultProps = {
    searchText: '',
    readOnly: false,
    readOnlyForPermission: false,
    isFarm: false,
    isMarketPlace: false,
    innerRef: noop,
    id: null,
    isRetailPage: false,
  };

  state = {
    currentTime: new Date().getTime(),
    storeData: [],
  };

  componentWillMount() {
    const { data } = this.props;
    this.setState({ storeData: data });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ storeData: nextProps.data });
    }
  }

  getDetailedData = () => {
    const {
      formatMessage,
      id,
      isFarm,
      isMarketPlace,
      readOnly,
      readOnlyForPermission,
      updateStateData,
      reloadStore,
      isRetailPage,
    } = this.props;
    const { storeData } = this.state;
    const detailData = [];
    const minCount = storeData.packrows.length > 0 ? minBy(storeData.packrows, 'count').count : 0;
    const image = storeData.image || null;

    storeData.packrows.forEach((packrow, index) => {
      if (packrow.count !== minCount) {
        detailData.push({
          ...storeData,
          ...packrow,
          bulkTotalQty: 0,
          category: storeData.productData.category,
          hide: [
            'status',
            'category',
            'name',
            'subname',
            'sourcename',
            'updatedAt',
            'action',
            'qty',
            'description',
            'tags',
            'approved',
          ],
          image,
          id: storeData.id,
          index,
          name: storeData.productData.name,
          subname: storeData.productData.subname,
        });
        return;
      }
      // const sourceApproved = !isMarketPlace && storeData.storeItemId && (
      //   <span
      //     className={`status-dot ${storeData.approved ? 'success' : 'failure'}`}
      //    title={formatMessage(`This Item has been Toggled-${storeData.approved ? 'On' : 'Off'}`)}
      //   />
      // );
      detailData.push({
        ...storeData,
        ...packrow,
        bulkTotalQty: storeData.packrows[0].isBulk ? storeData.availableQuantity : 0,
        action: readOnly ? (
          <div className="group-item-action">
            {storeData.seller.companyName && (
              <span className={`${storeData.approved ? 'category-title' : 'disable'}`}>
                {toStartCase(get(storeData, 'seller.companyName') || '')}
              </span>
            )}
            {storeData.productData.category && (
              <span className={`${storeData.approved ? 'category-title' : 'disable'}`}>
                {toStartCase(get(storeData, 'productData.category'))}
              </span>
            )}
            {storeData.productData.approved === false ? (
              <Badge type="pending">
                {formatMessage('Pending')}
              </Badge>
            ) : (
              <div className="d-flex align-items-center">
                <Toggle
                  disabled={readOnlyForPermission}
                  onToggle={(e, isInputChecked) =>
                    this.toggle(isInputChecked)}
                  title={formatMessage(storeData.approved ? 'Item Available' : 'Item Unavailable')}
                  toggled={storeData.approved}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="group-item-action">
            {storeData.productData.category && (
              <div className="category-pane">
                <span className={`${storeData.approved ? 'category-title' : 'disable'}`}>
                  {toStartCase(get(storeData, 'productData.category'))}
                </span>
              </div>
            )}
            <EditItemButton
              modeTable
              contactId={id}
              info={storeData}
              title={formatMessage('Edit')}
              updateStateData={modifiedData => updateStateData(this, {
                ...modifiedData,
                noDispatch: true,
              })}
              isApproved={isFarm ? storeData.approved : storeData.sourceApproved}
              reloadStore={reloadStore}
              isRetailPage={isRetailPage}
            />
            {/* <div>
              {moment(storeData.updatedAt).local().format('DD MMM')}
            </div> */}
            {storeData.productData.approved === false ? (
              <Badge type="pending">
                {formatMessage('Pending')}
              </Badge>
            ) : (
              <div className="d-flex align-items-center">
                <Toggle
                  disabled={readOnlyForPermission}
                  onToggle={(e, isInputChecked) =>
                    this.toggle(isInputChecked)}
                  title={formatMessage(storeData.approved ? 'Item Available' : 'Item Unavailable')}
                  toggled={storeData.approved}
                />
              </div>
            )}
            {
              !isFarm && storeData.isNew && !isMarketPlace && (
                <div className="new-item" title={formatMessage('New Item')}>
                  <Badge type="new-item" id={storeData.id}>
                    New
                  </Badge>
                </div>
              )
            }
          </div>
        ),
        category: storeData.productData.category,
        id: storeData.id,
        image,
        index,
        isMinCount: true,
        name: storeData.productData.name,
        subname: storeData.productData.subname,
      });
    });

    const sortedDetailData = sortBy(detailData, 'count');
    const fixWithEqualCountData = sortedDetailData.map((sortedDetailDataItem, index) => (
      (index > 0 && sortedDetailDataItem.count === minCount) ? {
        ...sortedDetailDataItem,
        hide: [
          'status',
          'category',
          'name',
          'subname',
          'sourcename',
          'updatedAt',
          'action',
          'qty',
          'description',
          'tags',
          'approved',
        ],
      } : sortedDetailDataItem
    ));

    return fixWithEqualCountData;
  }

  toggle = (toggled) => {
    const { updateStateData } = this.props;

    setTimeout(() => {
      updateStateData(this, { approved: toggled, noDispatch: true });
    }, 100);
  }

  render() {
    const { fields, innerRef, searchText, updateStateData } = this.props;
    const detailData = this.getDetailedData();
    const { storeData, currentTime } = this.state;
    const rowClassName = storeData.approved ? 'normal' : 'gray';
    return (
      <div ref={(c) => { this.dom = c; innerRef(c); }} key={currentTime}>
        <Divider
          color="grey"
          customStyle={rowClassName === 'gray' ?
            {
              marginTop: 10,
              marginBottom: 0,
              padding: 0,
              height: 20,
              borderTop: '1px solid black',
              backgroundColor: '#efefef',
            } : null
          }
        />
        <div className="table-card">
          {
            fields.map((field, index) => (
              <div className={`card-item-group ${rowClassName}`} key={index}>
                {
                  detailData.map((row, rowIndex) => {
                    const className = typeof field.className === 'function' ? field.className(row) : field.className;
                    const isEmpty = row.hide && row.hide.indexOf(field.name) > -1;
                    const value = field.render ? field.render({ ...row, instance: this, setState: (...args) => updateStateData(this, ...args) }) : (row.isSeparator ? '' : row[field.name]);
                    const searchedValue = !field.searchDisabled && !field.render && searchText
                      ? <HighlightText text={value} highlight={searchText} /> : value;

                    return (
                      <div
                        className={`card-item ${field.mobileHidden || isEmpty ? 'd-md-down-none' : ''}`}
                        key={rowIndex}
                      >
                        <div className="value">
                          <div className={className}>
                            {searchedValue}
                          </div>
                        </div>
                      </div>
                    );
                  })
                }
              </div>
            ))
          }
        </div>
      </div>
    );
  }
}

export default StoreMobileTableRow;
